import EmptyState from '@/components/linear/empty-state';
import PageToolbar from '@/components/linear/page-toolbar';

export default function Index() {
  return (
    <div className="ln-page">
      <PageToolbar title="Agents" showNew={false} />
      <EmptyState
        title="No agents"
        description="Linear-style agents that watch issues and pull requests will live here."
      />
    </div>
  );
}
